import {
  createContext,
  PropsWithChildren,
  ReactElement,
  useContext,
  useId,
  useMemo,
  useState
} from 'react';
import { EBetslipType } from 'interfaces/betslip';
import {
  EBetslipConfigsDispatchActions,
  TBetslipComputedConfigs,
  TBetslipStaticConfigs
} from 'newelements/_Betslip/types/configs';
import { TBetslipConfigsContext } from 'newelements/_Betslip/types/context';
import { useEventbus } from 'newhooks/generic/useEventbus';

const staticConfigsInitialValue = {
  betslipFixedHeight: false,
  floatingMode: false,
  betslipRootId: ''
};

const computedConfigsInitialValue: TBetslipComputedConfigs = {
  isOpened: false,
  mustOpen: false,
  mustClose: false,
  betslipType: EBetslipType.BASIC
};

const betslipConfigsContextInitialValue: TBetslipConfigsContext = {
  static: staticConfigsInitialValue,
  computed: computedConfigsInitialValue
};

export const BetslipConfigsContext = createContext(
  betslipConfigsContextInitialValue
);

export const BetslipConfigsContextProvider = ({
  children
}: PropsWithChildren): ReactElement => {
  const betslipRootId = useId();
  const [staticConfigs, setStaticConfigs] = useState<TBetslipStaticConfigs>({
    ...staticConfigsInitialValue,
    betslipRootId
  });

  const [computedConfigs, setComputedConfigs] =
    useState<TBetslipComputedConfigs>(computedConfigsInitialValue);

  // const setOpen = useCallback(
  //   (open: boolean) => {
  //     dispatch(setBetslipOpen(open));
  //
  //     if (!open && isMobile()) {
  //       dispatch(setFreezeTabChange(false));
  //
  //       if (!allLsBets.length && isLoggedIn) {
  //         dispatch(setActiveTabPage(EBetslipPage.OPEN_BETS));
  //       } else {
  //         dispatch(setActiveTabPage(EBetslipPage.BETSLIP));
  //       }
  //     }
  //   },
  //   [allLsBets, isLoggedIn]
  // );

  useEventbus({
    /* eslint-disable */
    // [EBetslipConfigsDispatchActions.SET_IS_OPENED]: (_, v?: boolean) => changeComputedConfigByKey('isOpened', v),
    // [EBetslipConfigsDispatchActions.SET_MUST_OPEN]: (_, v?: boolean) => changeComputedConfigByKey('mustOpen', v),
    // [EBetslipConfigsDispatchActions.SET_MUST_CLOSE]: (_, v?: boolean) => changeComputedConfigByKey('mustClose', v),
    [EBetslipConfigsDispatchActions.SET_BETSLIP_TYPE]: ({ payload }) =>
      changeComputedConfigByKey('betslipType', payload),
    [EBetslipConfigsDispatchActions.SET_STATIC_CONFIGS]: ({
      payload
    }: {
      payload: TBetslipStaticConfigs;
    }) => setStaticConfigs(p => ({ ...p, ...payload }))
    /* eslint-enable */
  });

  const configsContextValue = useMemo<TBetslipConfigsContext>(
    () => ({
      static: staticConfigs,
      computed: computedConfigs
    }),
    [staticConfigs, computedConfigs]
  );

  /**
   * Competition ids that must hide game info
   * @param  {key: keyof TBetslipComputedConfigs} key the key of property we want to change
   * @param  {value: TBetslipComputedConfigs[k]} value updated value, if you do not pass the value then the function works like toggle
   */
  const changeComputedConfigByKey = <T extends keyof TBetslipComputedConfigs>(
    key: T,
    // value?: TBetslipStaticConfigs[T]
    value?: any
  ) => {
    setComputedConfigs(prev => {
      return {
        ...prev,
        [key]: value !== undefined ? value : !prev[key]
      };
    });
  };

  return (
    <BetslipConfigsContext.Provider value={configsContextValue}>
      {children}
    </BetslipConfigsContext.Provider>
  );
};

export const useBetslipConfigsContext = (): TBetslipConfigsContext =>
  useContext(BetslipConfigsContext);
